import { useCallback, useState } from 'react';
import { useAuthTokenContext } from '../../providers/AuthTokenContext';

export const useFetch = (props?: UseFetchProps) => {
  const { getToken } = useAuthTokenContext();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<Response>();

  const doFetch = useCallback(
    async (url: string, options: RequestInit = {}) => {
      const token = getToken();

      if (!props?.noAuth)
        options.headers = { ...options.headers, Authorization: token };

      setLoading(true);
      try {
        const response = await fetch(`${props?.baseUrl || ''}${url}`, options);
        setResponse(response);
        return response;
      } finally {
        setLoading(false);
      }
    },
    [props, getToken],
  );

  return { fetch: doFetch, loading, response };
};

export interface UseFetchProps {
  noAuth?: boolean;
  baseUrl?: string;
}
